import { Button, Col, DatePicker, Input, Row, Select, Upload } from "antd";
import { Controller, useFormContext } from "react-hook-form";
import UploadField from "../UploadField";
import { UploadOutlined } from "@ant-design/icons";
import Error from "./Error";
import { identifier } from "stylis";
import dayjs from "dayjs";
import { fieldRules, numericRules, panRules } from "../Schema";
import TextArea from "antd/es/input/TextArea";
const Applicant = ({ id, ocfDisplayId }) => {
  const {
    control, // ✅ important
    formState: { errors },
  } = useFormContext();

  const colProps = { xs: 24, sm: 12, md: 12, lg: 8 };

  return (
    <>
      <Row gutter={[16, 16]} style={{ margin: "28px 0" }}>
        {/* Customer Name */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Customer Name</label>
            <Controller
              name="applicant.name"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.applicant?.name && "error"} />
              )}
            />
            <Error name="applicant.name" />
          </div>
        </Col>

        {/* Father/Husband Name */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Father/Husband Name</label>
            <Controller
              name="applicant.careOfName"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.applicant?.careOfName && "error"} />
              )}
            />
            <Error name="applicant.careOfName" />
          </div>
        </Col>

        {/* Email */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Customer Email</label>
            <Controller
              name="applicant.email"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.applicant?.email && "error"} />
              )}
            />
            <Error name="applicant.email" />
          </div>
        </Col>

        {/* Gender */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Gender</label>
            <Controller
              name="applicant.gender"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  style={{ width: "100%" }}
                  placeholder="Select gender"
                  status={errors.applicant?.gender && "error"}
                >
                  <Select.Option value="M">Male</Select.Option>
                  <Select.Option value="F">Female</Select.Option>
                </Select>
              )}
            />
            <Error name="applicant.gender" />
          </div>
        </Col>

        {/* Mobile */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Mobile</label>
            <Controller
              name="applicant.mobile"
              control={control}
              rules={numericRules(10, 10, "Mobile number", true)}
              render={({ field }) => (
                <Input
                  {...field}
                  maxLength={12}
                  inputMode="numeric"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    field.onChange(value);
                  }}
                  status={errors.applicant?.mobile ? "error" : ""}
                />
              )}
            />
            <Error name="applicant.mobile" />
          </div>
        </Col>

        {/* Alternate Mobile */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Alternate Number (Optional)</label>
            {/* <Controller
            name="applicant.mobile2"
            rules={numericRules(10, 10, "Alternate Mobile number", false)}
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                status={errors.applicant?.mobile2 && "error"}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  field.onChange(value);
                }}
              />
            )}
          /> */}
            <Controller
              name="applicant.mobile2"
              control={control}
              rules={{
                validate: (value) => {
                  if (!value) return true; // ✅ not mandatory
                  if (value.length !== 10) return "Enter a valid alternate mobile number";
                  return true;
                },
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  status={errors.applicant?.mobile2 && "error"}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    field.onChange(value);
                  }}
                />
              )}
            />

            <Error name="applicant.mobile2" />
          </div>
        </Col>

        {/* DOB */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Date of Birth</label>
            <Controller
              name="applicant.dob"
              control={control}
              render={({ field }) => (
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(date) => field.onChange(date ? date.format("YYYY-MM-DD") : null)}
                  status={errors.applicant?.dob && "error"}
                />
              )}
            />
            <Error name="applicant.dob" />
          </div>
        </Col>

        {/* Profession */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Profession</label>
            <Controller
              name="applicant.profession"
              control={control}
              render={({ field }) => (
                <Input {...field} status={errors.applicant?.profession && "error"} />
              )}
            />
            <Error name="applicant.profession" />
          </div>
        </Col>

        {/* Address */}
        <Col {...colProps}></Col>

        {/* Aadhar */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Aadhar Number</label>
            <Controller
              name="applicant.aadhar"
              control={control}
              rules={numericRules(12, 12, "Aadhar number", true)}
              render={({ field }) => (
                <Input
                  {...field}
                  status={errors.applicant?.aadhar && "error"}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 12);
                    field.onChange(value);
                  }}
                />
              )}
            />
            <Error name="applicant.aadhar" />

            <UploadField
              name="applicant.aadharFile"
              fieldType="customer_aadhar"
              label="Copy of Aadhar Card"
              ocfDisplayId={ocfDisplayId}
            />
            <Error name="applicant.aadharFile" />
          </div>
        </Col>

        {/* PAN */}
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">PAN Number</label>
            <Controller
              name="applicant.pan"
              control={control}
              rules={panRules}
              render={({ field }) => (
                <Input
                  {...field}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                    field.onChange(value);
                  }}
                  status={errors.applicant?.pan ? "error" : ""}
                />
              )}
            />
            <Error name="applicant.pan" />

            <UploadField
              name="applicant.panFile"
              fieldType="customer_pan"
              label="Copy of Pan Card"
              ocfDisplayId={ocfDisplayId}
            />
            <Error name="applicant.panFile" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={8} {...colProps}>
          <div className="form-field">
            <label className="form-label">Address</label>
            <Controller
              name="applicant.address"
              control={control}
              render={({ field }) => (
                <TextArea {...field} status={errors.applicant?.address && "error"} rows={4} />
              )}
            />
            <Error name="applicant.address" />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Applicant;
